<template>
  <div id="app" @mouseover="OperatingWebsite()">
    <router-view />
  </div>
</template>
<script>
import "./assets/css/iconfont.css";
/* 通用CSS */
import "./assets/css/common.css";
/* 日历CSS */
import "./assets/css/airbnb.css";
/* 图标管理css */
import "./assets/css/icon.css";

export default {
  data() {
    return {
      currentTime: new Date().getTime(),
    };
  },
  mounted() {},
  methods: {
    linkWeb() {
      // const truthPathQuery = this.$route.query.type;
      // const truthPath = this.$Base64.decode(truthPathQuery); //点击登录的时候跳转这个地址
    },
    OperatingWebsite() {
      // let currentTime = this.currentTime;
      // let lastTime = new Date().getTime();
      // let timeOut = 10 * 60 * 1000; //设置时间 10分钟
      // if (lastTime - currentTime > timeOut) {
      //   // 未操作页面，跳转登录页面
      //   this.currentTime = new Date().getTime();
      //   const fullPath = this.$route.fullPath;
      //   const query = this.$Base64.encode(fullPath);
      //   this.$router.push({
      //     path: "/user",
      //     query: {
      //       type: query
      //     }
      //   });
      // } else {
      //   this.currentTime = new Date().getTime();
      // }
    },
  },
};
</script>
<style lang="scss">
.el-select .el-input__inner:focus {
  border-color: #dcdfe6 !important;
}
.el-input__inner:focus {
  border-color: #d81212 !important;
}
.el-select .el-input.is-focus .el-input__inner {
  border-color: #d81212 !important;
}
.el-select-dropdown__item.selected {
  color: #d81212 !important;
}

.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #db1c1b !important;
}
</style>
